export default __webpack_public_path__ + "static/media/505.5d38c330.png";